import React from 'react';

interface checkboxProps {
    isChecked?: any;
    label: string;
    value: string;
    changeActiveFilter: any;
    filterOption: any;
    icon?: any;
    iconType?: any;
};

export function CheckboxButton(props: checkboxProps) {
    const label = props.label;
    const value = props.value;

    return <label className="label-container">
        {(label)}
        <input type="checkbox"
            onClick={() => props.changeActiveFilter(props.filterOption)}
            onChange={() => {
            }}
            value={(value)}
            name="filter-checkbox"
            checked={props.isChecked}/>
        <span className="checkmark"></span>
        {!!props.icon ?
            <span className={props.icon}></span> :
            ''}
    </label>;
}
